import { DatePipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { finalize, map, Observable, Subject } from 'rxjs';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { LocatiiService } from 'src/app/platform/nomenclatoare/locatii/locatii.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ProgramariService } from './programari.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import { ModuleService } from 'src/app/platform/nomenclatoare/module/module.service';
import { ModuleLocatiiActiveService } from 'src/app/platform/nomenclatoare/module-locatii-active/module-locatii-active.service';
import { IModulLocatieActivaFind } from 'src/app/platform/nomenclatoare/module-locatii-active/module-locatii-active.interface';
import { ModuleTipuriProgramActiveService } from 'src/app/platform/nomenclatoare/module-tipuri-program-active/module-tipuri-program-active.service';

@Component({
    selector: 'app-programari',
    templateUrl: './programari.component.html',
    styleUrls: ['./programari.component.scss']
})
export class ProgramariComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    helper = helper;
    isLoading = false;
    moduleId: number = -1;
    locatieId: number = -1;
    tipProgramare: number = 1;
    dataProgramare: Date = new Date();
    formattedDate: string = formatDate(this.dataProgramare, 'yyyy-MM-dd', 'en-US');

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    tipuriProgramari: { name: string; id: number }[] = [
        // { name: '--Alegeți--', id: -1 },
        { name: 'Programare Eveniment', id: 1 },
        { name: 'Programare Depunere', id: 2 },
    ];

    modules$!: Observable<Generic[]>;
    locatii$!: Observable<Generic[]>;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.deps.programari.listDT;

    constructor(
        private http: HttpClient,
        public permissionsService: PermissionsService,
        private programariService: ProgramariService,
        private moduleService: ModuleService,
        private moduleLocatiiActiveService: ModuleLocatiiActiveService,
        // private locatiiService: LocatiiService,
        // private moduleTipuriProgramActiveService: ModuleTipuriProgramActiveService,
        private appFilesService: AppFilesService,
        private datePipe: DatePipe,
    ) { }

    ngOnInit(): void {
        this.renderDT();
        // this.loadLocatii();
        this.loadModules();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                dataTablesParameters.id_modul = this.moduleId;
                dataTablesParameters.id_locatie = this.locatieId;
                dataTablesParameters.column = this.tipProgramare;
                dataTablesParameters.date = this.formattedDate;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID Cerere',
                    data: 'id_cerere',
                },
                {
                    title: 'Cetățean',
                    data: 'full_name',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span>${row.full_name || 'N/A'}</span>
						`;
                    },
                },
                {
                    title: 'Telefon',
                    data: 'telefon',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span>${row.telefon || 'N/A'}</span>
						`;
                    },
                },
                {
                    title: 'CNP',
                    data: 'cnp',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span>${row.cnp || 'N/A'}</span>
						`;
                    },
                },
                {
                    title: 'Programare',
                    data: 'programare',
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span>${row.programare || 'N/A'}</span>
						`;
                    },
                },
                {
                    title: 'Categorie/Tip',
                    data: 'type',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span>${row.type || 'N/A'}</span>
						`;
                    },
                },
                {
                    title: 'Dată Cerere',
                    data: 'created_at',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.created_at) {
                            return `
                                <span>${formatDate(row.created_at, 'dd.MM.yyyy HH:mm', 'en-US')}</span>
                            `;
                        } else {
                            return `
                                <span>N/A</span>
                            `;
                        }
                    },
                },
                {
                    title: 'Dată VALIDARE Programare',
                    data: 'validated_date',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span>${row.validated_date || 'N/A'}</span>
						`;
                    },
                },
            ],
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
    }

    loadModules() {
        this.isLoading = true;
        this.modules$ = this.moduleService.listModule().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    onModuleChange(moduleId: number): void {
        this.locatieId = -1;

        if (moduleId > 0) {
            this.findLocatiiByModul(moduleId);
        } else {
            this.locatii$ = new Observable<Generic[]>((observer) => {
                observer.next([this.defaultParameter])
                observer.complete();
            });
        }
    }

    findLocatiiByModul(moduleId: number) {
        this.isLoading = true;
        this.locatii$ = this.moduleLocatiiActiveService
            .findByModule(moduleId)
            .pipe(
                map((results: IModulLocatieActivaFind[]) => {
                    const data = results.map((item: IModulLocatieActivaFind) => ({
                        id: item.id_locatie,
                        name: item.nume_locatie,
                    }))
                    return [this.defaultParameter, ...data]
                }),
                finalize(() => (this.isLoading = false))
            )
    }

    // loadProgramTypesModul(moduleId: number) {
    //     this.isLoading = true;
    //     this.moduleTipuriProgramActiveService.findByModule(moduleId).pipe(
    //         map((results: any) => [this.defaultParameter, ...results]),
    //         finalize(() => (this.isLoading = false))
    //     )
    // }

    // loadLocatii() {
    //     this.isLoading = true;
    //     this.locatii$ = this.locatiiService.listLocatii().pipe(
    //         map((results: any) => [this.defaultParameter, ...results]),
    //         finalize(() => (this.isLoading = false))
    //     );
    // }

    onDateChange(event: any) {
        this.formattedDate = formatDate(event.value, 'yyyy-MM-dd', 'en-US');
        this.rerenderDT(true);
    }

    printProgramari() {
        const fullPath = this.programariService.printListProgramariURL;
        const payload = {
            id_locatie: this.locatieId,
            id_modul: this.moduleId,
            column: this.tipProgramare,
            date: this.formattedDate,
        }

        this.isLoading = true;
        this.appFilesService.postDownloadFile(fullPath, payload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }
}
